import { Box, CheckBox, ColorOptions, Spacer, Text } from '@jfs/ui-new'
import { useCallback, useState, useEffect } from 'react'

interface Props {
  value: string
  label: string
  onChange?: any
  showCheckbox?: boolean
  onPress?: () => void
  testID?: string
}
export const TextInputWithCb = ({ value, label, onChange, showCheckbox = false, onPress, testID = '' }: Props) => {
  const [checked, setChecked] = useState(false)
  const [hover, setHover] = useState(false)

  useEffect(() => {
    setChecked(false)
  }, [value])
  const update = useCallback((obj, isChecked) => onChange && onChange(obj, isChecked), [onChange])
  const handleOnChange = (isChecked: boolean) => {
    setChecked(isChecked)
    const obj = {
      [`${label}`]: value,
    }
    update(obj, isChecked)
  }
  const handleOnPress = () => {
    label === 'Link' && onPress && onPress()
  }
  return (
    <Box testID={testID}>
      <Box flexDirection={'row'} pv={4}>
        {showCheckbox && (
          <CheckBox
            testID={'cb-' + testID}
            checked={checked}
            iconSize={16}
            color={'#214796' as ColorOptions}
            onChecked={handleOnChange}
          />
        )}
        {showCheckbox && <Spacer direction={'horizontal'} size={4} />}
        <Text
          testID={'input-' + testID}
          title={label}
          fontFamily={'jiotype-bold'}
          fontSize={14}
          color={'#858796' as ColorOptions}
        />
      </Box>
      <Spacer direction={'vertical'} size={4} />
      <Box
        borderStyle={'dashed'}
        borderWidth={1}
        borderRadius={4}
        borderColor={'#858796' as ColorOptions}
        h={38}
        ph={8}
        bg={'WHITE'}
        onPress={handleOnPress}
        underlayColor={'TRANSPARENT'}
        onHover={setHover}
        justify={'center'}>
        <Text
          title={label === 'Link' ? 'Download' : value?.toString()}
          fontFamily={'jiotype-medium'}
          color={label === 'Link' ? 'PRIMARY' : 'BLACK_21'}
          numberOfLines={1}
          textDecorationLine={hover && label === 'Link' ? 'underline' : 'none'}
        />
      </Box>
    </Box>
  )
}
